import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-pdf',
  templateUrl: './pdf.html',
  styleUrl: './pdf.scss',
})
export class Pdf {
  width = input<string>('1rem');
  height = input<string>('1rem');
}
